<script setup lang="ts">
import { usePlaceStore } from "@/modules/place-module";
import { computed } from "vue";
import { IconScheduleFill } from "@packages/icon-library";
import { useI18n } from "vue-i18n";

const placeStore = usePlaceStore();
const place = computed(() => placeStore.place);
const { t } = useI18n();
</script>

<template>
  <section class="place-work-time">
    <IconScheduleFill />

    <div class="place-work-time__info">
      <h4>{{ t("place.workTime") }}</h4>

      <p v-for="(item, index) in place?.place.working_schedule" :key="index">
        {{ item.days }}:
        <span :class="{ weekend: item.is_weekend, around: item.is_247 }">{{
          item.time
        }}</span>
      </p>
    </div>
  </section>
</template>

<style scoped lang="scss">
.place-work-time {
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: calc($base-space * 2);
  align-items: start;

  @media (max-width: 1023px) {
    grid-template-columns: 20px 1fr;
  }

  > .icon {
    background-color: var(--color-semantic-content-normal-contrast-secondary);

    @media (max-width: 1023px) {
      width: 20px;
      height: 20px;
    }
  }

  &__info {
    > h4 {
      @include body-bold-l();
      color: var(--color-semantic-content-normal-primary);
    }

    > p {
      text-transform: lowercase;
      @include body-m();
      color: var(--color-semantic-content-normal-primary);

      @media (max-width: 1023px) {
        margin: calc($base-space * 2) 0 0;
        padding: 0 $base-space;
      }

      &:first-of-type {
        margin: calc($base-space * 3) 0 0;

        @media (max-width: 1023px) {
          margin: calc($base-space * 2) 0 0;
        }
      }

      &:not(:first-of-type) {
        margin: calc($base-space * 2) 0 0;
      }

      > span {
        &.weekend {
          color: var(--color-semantic-content-normal-warning);
        }

        &.around {
          color: var(--color-semantic-content-normal-positive);
        }
      }
    }
  }
}
</style>
